// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.Slide_card__qAxPF {
    padding: 15px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    /* transition: transform 0.3s ease, box-shadow 0.3s ease; */
    cursor: pointer;
    /* margin-left: 15px; */
    background-color: #fff;
    width: 100%;
    text-align: center;
     border: 1px solid rgb(226, 225, 225);
}


@media (min-width: 1800px) {
    .Slide_card__qAxPF {
        height: 150px; 
    }
}


@media (max-width: 1700px) and (min-width: 992px) {
    .Slide_card__qAxPF {
        height: 130px;
    }
}

/* Màn hình từ 768px đến 991px (Tablet) */
@media (max-width: 991px) and (min-width: 768px) {
    .Slide_card__qAxPF {
        height: 130px;
    }
}

/* Màn hình từ 576px đến 767px (Tablet nhỏ) */
@media (max-width: 767px) and (min-width: 576px) {
    .Slide_card__qAxPF {
        height: 130px;
    }
}

/* Màn hình nhỏ hơn 576px (Điện thoại nhỏ) */
@media (max-width: 575px) {
    .Slide_card__qAxPF {
        height: 130px;
    }
}
.Slide_imgContainer__ERlgV {
    display: flex;
    justify-content: center; /* Căn giữa theo chiều ngang */
    align-items: center; /* Căn giữa theo chiều dọc */
    height: 100%; /* Đảm bảo container có chiều cao */
}

.Slide_image__Nj7uY {
    max-width: 100%; /* Đảm bảo hình ảnh không vượt quá chiều rộng */
    height: auto; /* Tự động điều chỉnh chiều cao */
}
/* Slide.module.css */
/* Slide.module.css */
.Slide_selectedParent__SXBRX {
    border: 2px solid #477ED2; /* Màu viền xanh khi hệ thống con được chọn */
    padding: 10px;
    border-radius: 5px;
}


.Slide_formselect__1XRzw {
    border: 1px solid #ddd; 
    width: 100%;
    padding: 5px;
    color: #333;
    cursor: pointer;
}

.Slide_formselect__1XRzw:focus {
    border-color:rgb(165, 232, 233) ;
    outline: none; 
    border-radius: 0px;
}
.Slide_formselect__1XRzw option {
    font-size: 12px; 
    text-align: center;
}
/* 
.formselect option:first-child {
    font-size: 10px; 
} */

/* Thêm mũi tên ở góc trên bên phải của card */
.Slide_cardWithArrow__xhXqa {
    position: relative; /* Để mũi tên có thể được đặt tuyệt đối trong card */
}

.Slide_cardWithArrow__xhXqa.Slide_selected__vEcBd::after {
    content: '✔';  
    position: absolute;
    top: -4px; 
    right: 10px; 
    color: #0069ff;
    font-size: 24px;
    font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/css/Slide.module.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,yCAAyC;IACzC,kBAAkB;IAClB,2DAA2D;IAC3D,eAAe;IACf,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;IACX,kBAAkB;KACjB,oCAAoC;AACzC;;;AAGA;IACI;QACI,aAAa;IACjB;AACJ;;;AAGA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA,yCAAyC;AACzC;IACI;QACI,aAAa;IACjB;AACJ;;AAEA,6CAA6C;AAC7C;IACI;QACI,aAAa;IACjB;AACJ;;AAEA,4CAA4C;AAC5C;IACI;QACI,aAAa;IACjB;AACJ;AACA;IACI,aAAa;IACb,uBAAuB,EAAE,8BAA8B;IACvD,mBAAmB,EAAE,4BAA4B;IACjD,YAAY,EAAE,mCAAmC;AACrD;;AAEA;IACI,eAAe,EAAE,+CAA+C;IAChE,YAAY,EAAE,iCAAiC;AACnD;AACA,qBAAqB;AACrB,qBAAqB;AACrB;IACI,yBAAyB,EAAE,6CAA6C;IACxE,aAAa;IACb,kBAAkB;AACtB;;;AAGA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;;;GAGG;;AAEH,8CAA8C;AAC9C;IACI,kBAAkB,EAAE,oDAAoD;AAC5E;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB","sourcesContent":["\r\n.card {\r\n    padding: 15px;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\r\n    border-radius: 5px;\r\n    /* transition: transform 0.3s ease, box-shadow 0.3s ease; */\r\n    cursor: pointer;\r\n    /* margin-left: 15px; */\r\n    background-color: #fff;\r\n    width: 100%;\r\n    text-align: center;\r\n     border: 1px solid rgb(226, 225, 225);\r\n}\r\n\r\n\r\n@media (min-width: 1800px) {\r\n    .card {\r\n        height: 150px; \r\n    }\r\n}\r\n\r\n\r\n@media (max-width: 1700px) and (min-width: 992px) {\r\n    .card {\r\n        height: 130px;\r\n    }\r\n}\r\n\r\n/* Màn hình từ 768px đến 991px (Tablet) */\r\n@media (max-width: 991px) and (min-width: 768px) {\r\n    .card {\r\n        height: 130px;\r\n    }\r\n}\r\n\r\n/* Màn hình từ 576px đến 767px (Tablet nhỏ) */\r\n@media (max-width: 767px) and (min-width: 576px) {\r\n    .card {\r\n        height: 130px;\r\n    }\r\n}\r\n\r\n/* Màn hình nhỏ hơn 576px (Điện thoại nhỏ) */\r\n@media (max-width: 575px) {\r\n    .card {\r\n        height: 130px;\r\n    }\r\n}\r\n.imgContainer {\r\n    display: flex;\r\n    justify-content: center; /* Căn giữa theo chiều ngang */\r\n    align-items: center; /* Căn giữa theo chiều dọc */\r\n    height: 100%; /* Đảm bảo container có chiều cao */\r\n}\r\n\r\n.image {\r\n    max-width: 100%; /* Đảm bảo hình ảnh không vượt quá chiều rộng */\r\n    height: auto; /* Tự động điều chỉnh chiều cao */\r\n}\r\n/* Slide.module.css */\r\n/* Slide.module.css */\r\n.selectedParent {\r\n    border: 2px solid #477ED2; /* Màu viền xanh khi hệ thống con được chọn */\r\n    padding: 10px;\r\n    border-radius: 5px;\r\n}\r\n\r\n\r\n.formselect {\r\n    border: 1px solid #ddd; \r\n    width: 100%;\r\n    padding: 5px;\r\n    color: #333;\r\n    cursor: pointer;\r\n}\r\n\r\n.formselect:focus {\r\n    border-color:rgb(165, 232, 233) ;\r\n    outline: none; \r\n    border-radius: 0px;\r\n}\r\n.formselect option {\r\n    font-size: 12px; \r\n    text-align: center;\r\n}\r\n/* \r\n.formselect option:first-child {\r\n    font-size: 10px; \r\n} */\r\n\r\n/* Thêm mũi tên ở góc trên bên phải của card */\r\n.cardWithArrow {\r\n    position: relative; /* Để mũi tên có thể được đặt tuyệt đối trong card */\r\n}\r\n\r\n.cardWithArrow.selected::after {\r\n    content: '✔';  \r\n    position: absolute;\r\n    top: -4px; \r\n    right: 10px; \r\n    color: #0069ff;\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `Slide_card__qAxPF`,
	"imgContainer": `Slide_imgContainer__ERlgV`,
	"image": `Slide_image__Nj7uY`,
	"selectedParent": `Slide_selectedParent__SXBRX`,
	"formselect": `Slide_formselect__1XRzw`,
	"cardWithArrow": `Slide_cardWithArrow__xhXqa`,
	"selected": `Slide_selected__vEcBd`
};
export default ___CSS_LOADER_EXPORT___;
